import { useRef, useState } from "react";
import Button from "./Button";
import { bytesToSize } from "../../utils/format";

export default function FileUploadZone({ onFiles, uploading = false, progressByFile = {} }) {
  const [drag, setDrag] = useState(false);
  const [preview, setPreview] = useState([]);
  const fileInputRef = useRef(null);

  const handleFiles = (files) => {
    if (!files?.length) return;
    const picked = Array.from(files);
    setPreview(picked);
    onFiles(picked);
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDrag(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div
      className={`upload-zone ${drag ? "drag" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        setDrag(true);
      }}
      onDragLeave={() => setDrag(false)}
      onDrop={onDrop}
    >
      <div style={{ fontSize: 32, color: "var(--color-electric)" }}>↑</div>
      <p style={{ color: "var(--color-ink)", fontSize: 14 }}>Drop PDF here or browse files</p>
      <input
        ref={fileInputRef}
        hidden
        type="file"
        multiple
        accept="application/pdf"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <Button variant="secondary" onClick={() => fileInputRef.current?.click()} disabled={uploading}>
        Browse Files
      </Button>
      {preview.length ? (
        <div className="upload-preview-list">
          {preview.map((file) => (
            <div key={`${file.name}-${file.lastModified}`} className="upload-preview-item">
              <div className="row-between">
                <span>
                  {file.name} ({bytesToSize(file.size)})
                </span>
                {progressByFile[file.name] !== undefined ? <span>{progressByFile[file.name]}%</span> : null}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
